var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 16.998V41.998C36 43.103 35.105 43.998 34 43.998H10C8.895 43.998 8 43.103 8 41.998V9.99805C8 8.89305 8.895 7.99805 10 7.99805H27L36 16.998Z",
    fill: "#0044C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M10 7.99805H27L36 16.998V41.998H13.681C11.648 41.998 10 40.35 10 38.317V7.99805Z",
    fill: "#000004",
    fillOpacity: 0.298039
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M11 7.99805H27L36 16.998V40.998H13.839C12.271 40.998 11 39.727 11 38.159V7.99805Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13.998V37.998C40 39.103 39.105 39.998 38 39.998H14C12.895 39.998 12 39.103 12 37.998V5.99805C12 4.89305 12.895 3.99805 14 3.99805H30L40 13.998Z",
    fill: "#1F6CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.99805V11.998C30 13.103 30.895 13.998 32 13.998H40L30 3.99805Z",
    fill: "url(#paint0_linear_3089_102271)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3203 20.9326H18.3203C18.0443 20.9326 17.8203 20.7086 17.8203 20.4326V19.4326C17.8203 19.1566 18.0443 18.9326 18.3203 18.9326H33.3203C33.5963 18.9326 33.8203 19.1566 33.8203 19.4326V20.4326C33.8203 20.7086 33.5963 20.9326 33.3203 20.9326Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3203 24.9316H18.3203C18.0443 24.9316 17.8203 24.7076 17.8203 24.4316V23.4316C17.8203 23.1556 18.0443 22.9316 18.3203 22.9316H33.3203C33.5963 22.9316 33.8203 23.1556 33.8203 23.4316V24.4316C33.8203 24.7076 33.5963 24.9316 33.3203 24.9316Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3203 28.9316H18.3203C18.0443 28.9316 17.8203 28.7076 17.8203 28.4316V27.4316C17.8203 27.1556 18.0443 26.9316 18.3203 26.9316H33.3203C33.5963 26.9316 33.8203 27.1556 33.8203 27.4316V28.4316C33.8203 28.7076 33.5963 28.9316 33.3203 28.9316Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3203 32.9326H18.3203C18.0443 32.9326 17.8203 32.7086 17.8203 32.4326V31.4326C17.8203 31.1566 18.0443 30.9326 18.3203 30.9326H29.3203C29.5963 30.9326 29.8203 31.1566 29.8203 31.4326V32.4326C29.8203 32.7086 29.5963 32.9326 29.3203 32.9326Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3089_102271",
    x1: 30.534,
    y1: 13.464,
    x2: 35.09,
    y2: 8.90805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003BAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#033189"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyicon);
export default __webpack_public_path__ + "static/media/Copyicon.65728bd6320d1af43572f61fb988042b.svg";
export { ForwardRef as ReactComponent };